export const rules = {
    model: [{
        required: true,
        message: 'Пожалуйста, введите название ',
        trigger: 'change'
    },]
};
